import {useCallback, useContext, useEffect, useRef, useState} from 'react'

import type {JobGameTabContextValue} from './GameTab.contexts'
import {JobGameTabContextContext, JobGameTabContextDefaultValue} from './GameTab.contexts'

export function useGameTab() {
  const iframe = useRef<HTMLIFrameElement>(null)
  const focusIframe = useCallback(() => iframe.current?.contentWindow?.focus(), [])

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      switch (e.key) {
        case 'ArrowUp':
        case 'ArrowRight':
        case 'ArrowDown':
        case 'ArrowLeft':
          focusIframe()
          break
        default:
      }
    }
    document.addEventListener('keydown', listener)
    return () => document.removeEventListener('keydown', listener)
  })

  return {
    iframe,
    focusIframe,
  }
}

export function useJobGameTabContextValue(): JobGameTabContextValue {
  const [wasFound, setWasFound] = useState(JobGameTabContextDefaultValue.wasFound)
  return {wasFound, setWasFound}
}

export function useJobGameTabContext(): JobGameTabContextValue {
  return useContext(JobGameTabContextContext)
}
